/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".fixedHeight_0d28bbbd{height:300px}\n"}]);
export const fixedHeight = "fixedHeight_0d28bbbd";